'use strict';
var BaseModel = require('./Base');
var Model;

module.exports = Model = BaseModel.extend('CompanyLocation', {
    softDelete: false,

    defaults: {
        name: 'HQ',
        company: null,
        address: null,
        primary: true
    },

    constraints: {
        name: {presence: {message: '^Name is required'}},
        company: {presence: true},
        primary: {presence: true}
    },

    initialize: function() {
        BaseModel.prototype.initialize.apply(this, arguments);

        this.proxyAddressChangeEvent();
    },

    proxyAddressChangeEvent: function() {
        var self = this;
        var _address = false;
        var bind = function() {
            _address = self.get('address');
            _address.on('change', function(model, options) {
                self.trigger('change', self, options);
                self.trigger('change:address', self, options);
            });
        };

        if (self.get('address')) {
            bind();
        }

        self.on('change:address', function() {
            if (self.get('address')) {
                if (_address) {
                    _address.off('change');
                }
                bind();
            }
        }, self);
    },

    /* NOTE We need to validate the address contained in this object and a
     * simple constraint doesn't cut it as we need an error per attribute
     * in the address class.
     * To overcome this I run BaseModel validation and append the address
     * model errors to the result.
     *
     * The good: validation for this model works as expected by any backbone
     * dev. The bad: BaseModel.validation() is too complex and we now are
     * required to keep an eye out to avoid this method from breaking which
     * is likely to happen in the future.
     * */
    validate: function(attrs, options) {
        var self = this;
        BaseModel.prototype.validate.apply(self, arguments);

        if (self.get('address') && self.get('primary') === true) {
            var r = self.get('address').validate(
                self.get('address').attributes, options
            );

            if (r !== false) {
                self.validationError = _.extend(
                    self.validationError || {}, r.validationError
                );
            }
        }

        return (
            _.isObject(self.validationError) &&
            !_.isEmpty(self.validationError)
        ) ? {
            code: 1100,
            error: 'Validation error',
            errors: self.validationError
        } : false;
    },

    dirty: function() {
        var self = this;
        var dirty = BaseModel.prototype.dirty.apply(this, arguments);

        if (self.get('address')) {
            dirty = dirty || self.get('address').dirty();
        }

        return dirty;
    },

    isValid: function() {
        var self = this;
        var valid = BaseModel.prototype.isValid.apply(self, arguments);
        const hasState = self.get('address').get('state') !== '';

        if (self.get('address') && self.get('primary') === true) {
            valid = valid && self.get('address').isValid();
        } else if (!hasState) {
            valid = false;
        }

        return valid;
    },

    wasValid: function() {
        let address = this.get('address');
        if (!address) {
            return true;
        }

        return (
            this.getValidationError() === false ||
                _.isEmpty(this.getValidationError())
        );
    },

    getValidationError: function() {
        let address = this.get('address');
        let addressValidationError = {};
        if (address) {
            addressValidationError = address.validationError;
        }
        return _.extend({}, this.validationError, addressValidationError);
    }
}, {
    fetchById: function(id) {
        return (new Parse.Query('CompanyLocation'))
            .include('address')
            .include('company')
            .get(id);
    },

    fetchForCompany: function(company) {
        return (new Parse.Query('CompanyLocation'))
            .equalTo('company', company)
            .include('company')
            .include('address')
            .first();
    },

    fetchAllForCompany: function(company) {
        return new Parse.Query('CompanyLocation')
            .equalTo('company', company);
    },

    fetchPrimaryForCompany: function(company) {
        return (new Parse.Query('CompanyLocation'))
            .equalTo('company', company)
            .equalTo('primary', true)
            .include('company')
            .include('address')
            .first();
    }
});



// WEBPACK FOOTER //
// ./app/models/CompanyLocation.js